import { useContext } from 'react'
import { AppContext } from '../providers/AppProvider.jsx'

export const useApp = () => useContext(AppContext)